import { Box, ChakraProps } from "@chakra-ui/react"
import { wobbleAnimation } from "../../styles/theme"
import { route } from "preact-router"

type HTMLProps = { children: string; animateLinks?: boolean } & ChakraProps
export const HTML = ({
  children,
  animateLinks = true,
  ...props
}: HTMLProps) => {
  return (
    <Box
      sx={{
        a: {
          display: animateLinks ? "inline-block" : undefined,
          textDecoration: "underline",
          "&:hover": {
            animation: `${wobbleAnimation} 2s infinite linear`,
          },
        },
        "p:not(:last-child)": {
          marginBottom: "1rem",
        },
      }}
      dangerouslySetInnerHTML={{
        __html: children.trim().replace(/\n/g, "<br/>"),
      }}
      onClick={(e: any) => {
        if ((e.target as HTMLElement).tagName === "A") {
          const href = (e.target as HTMLAnchorElement).getAttribute("href")
          if (!href) return
          const url = new URL(href, window.location.origin)
          if (url.origin === window.location.origin) {
            e.preventDefault()
            route(url.pathname)
          }
        }
      }}
      {...props}
    />
  )
}
